<template>
  <ComponentListContainer
    ref="list"
    :key="componentType"
    :resource-id="resourceId"
    :resource="resource"
    :can-edit="!disabled"
    :can-delete="!disabled"
    :can-create="!(isCreateDisabled || disabled)"
    :type="componentType"
    :fetch-fn="fetchData"
    :create-fn="createData"
    :update-fn="updateData"
    :delete-fn="deleteData"
    :searchable="
      [SOFTWARE_COMPONENT, MOBILE_APPLICATION_COMPONENT].indexOf(
        componentType
      ) >= 0
    "
    :module-name="moduleName"
    as-table
  />
</template>

<script>
import { buildRelationalQualificationStructure } from '@data/qualification'
import {
  createAssetComponentApi,
  updateAssetComponentApi,
  searchAssetComponentsApi,
  addSoftwareComponentApi,
  deleteAssetComponentApi,
} from '../../asset-api'
import {
  MOBILE_APPLICATION_COMPONENT,
  SOFTWARE_COMPONENT,
} from '../../helpers/asset'
import ComponentListContainer from '../propery-component-list/propery-component-list-container'
export default {
  name: 'ComponentTab',
  components: { ComponentListContainer },
  props: {
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    componentType: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    moduleName: { type: String, required: true },
    isCreateDisabled: { type: Boolean, default: false },
  },
  data() {
    this.SOFTWARE_COMPONENT = SOFTWARE_COMPONENT
    this.MOBILE_APPLICATION_COMPONENT = MOBILE_APPLICATION_COMPONENT
    return {}
  },
  methods: {
    fetchData(qual, limit, offset) {
      if (this.componentType) {
        let qualList = []
        if ([SOFTWARE_COMPONENT].indexOf(this.componentType) >= 0) {
          qualList = qual.name
            ? [
                buildRelationalQualificationStructure(
                  'softwareName',
                  'contains',
                  qual.name,
                  'string',
                  'db'
                ),
              ].filter(Boolean)
            : []
        }

        if ([MOBILE_APPLICATION_COMPONENT].indexOf(this.componentType) >= 0) {
          qualList = qual.name
            ? [
                buildRelationalQualificationStructure(
                  'appName',
                  'contains',
                  qual.name,
                  'string',
                  'db'
                ),
              ].filter(Boolean)
            : []
        }

        return searchAssetComponentsApi(
          this.moduleName,
          qualList,
          this.resourceId,
          this.componentType,
          limit,
          offset
        )
      }
    },
    createData(data) {
      if (
        [SOFTWARE_COMPONENT, MOBILE_APPLICATION_COMPONENT].indexOf(
          this.componentType
        ) >= 0
      ) {
        return addSoftwareComponentApi(this.resourceId, data)
      }
      return createAssetComponentApi(this.moduleName, this.resourceId, {
        ...data,
        type: this.componentType,
      })
    },
    updateData(data) {
      return updateAssetComponentApi(this.moduleName, data)
    },
    deleteData(id) {
      return deleteAssetComponentApi(this.moduleName, this.componentType, id)
    },
  },
}
</script>
